<template>
    <div>
        <md-table>
            <md-table-row>
                <md-table-head>&nbsp;</md-table-head>
                <md-table-head v-for="field in sortedFieldDefinitions" :key="`header-${field.group}`">
                    {{ field.label }}
                </md-table-head>
            </md-table-row>
            <md-table-row v-for="(report, repNdx) in reports" :key="`member-${repNdx}`">
                <md-table-cell>{{ report.fullName }}</md-table-cell>
                <md-table-cell
                    v-for="(field, fldNdx) in sortedFieldDefinitions"
                    :key="`${repNdx}-${field.group}-${fldNdx}`"
                >
                    <div v-html="getExpiryDate(report.documents, field.group)"></div>
                </md-table-cell>
            </md-table-row>
        </md-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DATE_TYPES } from '@/utils/constants';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { STANDALONE_FIELDS_GROUP } from '@/utils/customFields';

export default {
    name: 'TeamMemberDocumentReportMatrix',
    props: {
        reports: {
            type: Array,
            required: true
        }
    },
    mixins: [GeneralMixin],
    data() {
        return { standaloneFieldsGroupName: STANDALONE_FIELDS_GROUP };
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
        teamMemberCustomFieldDefinitions() {
            return this.user.teamMemberCustomFieldDefinitions || [];
        },
        sortedFieldDefinitions() {
            return this.teamMemberCustomFieldDefinitions
                .filter((x) => x.group !== this.standaloneFieldsGroupName)
                .slice()
                .sort((a, b) => a.label.localeCompare(b.label));
        }
    },
    methods: {
        getDocument(documents, groupName) {
            return documents.find((doc) => doc.groupName === groupName);
        },
        getExpiryDate(documents, groupName) {
            const doc = this.getDocument(documents, groupName);

            if (doc && doc.expiryDate) {
                const today = new Date();
                const expiryDate = new Date(doc.expiryDate);
                const timeDiff = expiryDate - today;
                const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

                const formattedDate = this.$options.filters.dateFormat(doc.expiryDate, DATE_TYPES.standardDate);
                if (daysDiff < 0) {
                    return `<span class="expired">${formattedDate}</span>`;
                }
                if (daysDiff < 30) {
                    return `<span class="expiringSoon">${formattedDate}</span>`;
                }

                return formattedDate;
            }

            return '';
        }
    }
};
</script>

<style scoped>
::v-deep .expired {
    color: red;
}

::v-deep .expiringSoon {
    color: orange;
}
</style>
